import { MultiSelect } from 'react-multi-select-component';
import PropTypes from 'prop-types';

const MultiSelectComponent = ({
    options,
    selected,
    onChange,
    placeholder = 'Select options',
    allSelectedMessage = 'All options are selected',
    error,
    disabled = false,
    isCreatable = false,
}) => {

    const dropdownStyle = {
        zIndex: "inherit",
    };

    return (
        <div>
            <MultiSelect
                options={options}
                value={selected}
                onChange={onChange}
                disabled={disabled}
                isCreatable={isCreatable}
                overrideStrings={{
                    selectSomeItems: placeholder,
                    allItemsAreSelected: allSelectedMessage,
                }}
                // style={{ ...dropdownStyle }}
                style={{
                    multiselectContainer: {
                        border: "1px solid #ced4da",
                        borderRadius: "6px",
                        minHeight: "38px",
                        zIndex: "inherit",
                    },
                    searchBox: {
                        border: "none"
                    }
                }}
            />
            {error && <span className="text-danger">{error}</span>}
        </div>
    );
};

MultiSelectComponent.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })).isRequired,
    selected: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    allSelectedMessage: PropTypes.string,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    isCreatable: PropTypes.bool,
};

export default MultiSelectComponent;
